import { X } from 'lucide-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Bottom-sheet on mobile, centered dialog on desktop, with a header showing the
 * "家长评论 · N 条评论" title and a scrollable body. Used by the "查看全部" entries
 * on both the activity detail page and the host page.
 */
export default function ReviewsModalShell({
  total,
  onClose,
  children,
}: {
  total: number;
  onClose: () => void;
  children: ReactNode;
}) {
  const { t } = useTranslation('review');
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:p-4">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75" onClick={onClose} />
      <div className="relative bg-white rounded-t-2xl sm:rounded-lg shadow-xl w-full sm:max-w-lg max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between p-4">
          <h3 className="text-lg font-bold text-gray-900">
            {t('title')}
            <span className="ml-2 text-sm font-normal text-gray-500">
              {t('reviewCount', { count: total })}
            </span>
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500"
            aria-label={t('editor.cancel')}
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="p-4 overflow-y-auto">{children}</div>
      </div>
    </div>
  );
}
